"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={ref} className="relative flex min-h-screen items-center justify-center overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/image_m77ulrhs.jpg)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />

      {}
      <div className={`relative z-10 max-w-4xl px-6 text-center transition-all duration-[150ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
        <h1 className="font-display text-5xl font-bold leading-tight text-foreground-dark sm:text-6xl lg:text-7xl">&nbsp;Sydney Wedding Videography and Photography for your special day</h1>

        <p className="mt-6 text-lg leading-relaxed text-foreground-dark/90 sm:text-xl">AB Studios provides wedding photography and videography across Sydney, Eastern Suburbs, Inner West, North Shore, Sutherland Shire, with NSW travel available</p>

        <div className="mt-8">
          <Link to="mailto:aidan.bartlett.photography@gmail.com">
            <Button size="lg" className="rounded-md bg-[#B86A5A] text-white px-8 py-4 text-base font-semibold shadow-medium transition-all duration-[120ms] ease-in-out hover:scale-[1.03] hover:bg-[#A55A4A] hover:shadow-strong focus-visible:ring-2 focus-visible:ring-[#B86A5A]/40">
              Lock in your special day now
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}